import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import { getDisplayName, getUserId } from '@src/model/user/helpers';
import creatorSdk from '@src/services/creator-sdk';
import { postsAtom, setPost } from '../posts/posts';
import { jotaiStore } from '../store';

export interface Flair {
    name: string;
    color: string;
    id: string;
}

export interface CreateFlairApiRequestPayload {
    tokenName: string;
    userId: string;
    flairColor: string;
    flairName: string;
}

export interface DeleteFlairApiRequestPayload {
    tokenName: string;
    userId: string;
    flairName: string;
}

export interface AttachFlairApiRequestPayload {
    userId: string;
    postId: string;
    tokenName: string;
    flairName: string | ''; // '' means detach flair
}

export const createFlair = async (payload: CreateFlairApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Flair>>(
        '/flair/create',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false,
    );
    return data;
};

export const deleteFlair = async (payload: DeleteFlairApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Flair>>(
        '/flair/delete',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false,
    );
    return data;
};

export const attachFlair = async (payload: AttachFlairApiRequestPayload) => {
    const { postId, flairName } = payload;

    jotaiStore.set(postsAtom, draft => {
        const post = draft[postId];
        if (!post) throw new Error(`[attachFlair] post with id ${postId} not found`);
        const currentFlairs = post.flairs || [];
        console.log(`[attachFlair] currentFlairs: ${currentFlairs}`);

        if (currentFlairs.includes(flairName)) post.flairs = [];
        else post.flairs = [flairName];
    });

    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Flair>>(
        '/flair/attach',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false,
    );

    return data;
};
